import { Show, useTranslate } from "react-admin"
import CustomerShowLayout from "./CustomerShowLayout"

const CustomerShow = () => {
  const translate = useTranslate()

  return (
    <Show title={translate("resources.customers.name", {smart_count: 1})} >
      <CustomerShowLayout />
    </Show>
  )
}

export default CustomerShow